import { selector } from "recoil";
import { medicineUpdate } from "./atoms";


export const medicineUpdateSelector = selector({
  key: "medicineUpdateSelector",
  get: ({ get }) => {
    return get(medicineUpdate); // Get the current value of medicineUpdate
  },
  set: ({ set }, newValue) => {
    set(medicineUpdate, newValue); // Set medicineUpdate to the new value
  },
});
